import en from './en';
import fr from './fr';
import de from './de';

const resources = { en, fr, de };

export default resources;
